// extracted by mini-css-extract-plugin
module.exports = {"Gallery":"Gallery_Gallery__Mrjdw","GalleryFrame":"Gallery_GalleryFrame__3MRsE","GalleryStrip":"Gallery_GalleryStrip__9DCcb"};